import React, { useRef, useEffect } from 'react';

function usePrevious( value: any ): any{
	
	const ref = useRef();
	
	useEffect( () => {
		ref.current = value;
	} );
	
	return ref.current;
}

//@ts-ignore
export { usePrevious };
